<script>
import dialogMixin from './mixins/dialog'
import { messageSuccess, messageDanger } from '@utils/message'

export default {
  mixins: [dialogMixin],
  props: {
    orderItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    confirm() {
      const vm = this
      vm.$store
        .dispatch('order/cancelOrder', {
          eventAlias: vm.orderItem.alias,
          seriesNum: vm.orderItem.seriesNum,
          uuids: vm.uuidRun(),
        })
        .then((res) => {
          if (res.code === 200) {
            vm.dialogMixinDialogVisible = false
            messageSuccess(res.message)
          }
        })
        .catch(() => {
          console.log('catch')
          messageDanger('取消報名失敗')
        })
        .finally(() => {
          setTimeout(() => {
            location.reload()
          }, 500)
        })
    },
    uuidRun() {
      const vm = this
      const getIsEventList = vm.orderItem.sessions.map((item) => {
        return item.sessions.filter((item2) => {
          return item2.uuid
        })
      })
      const reduceIsEventList = getIsEventList.reduce((prev, curr) => {
        return [...prev, ...curr]
      })
      const list = reduceIsEventList.map((item) => {
        return item.uuid
      })
      return [...new Set(list)]
    },
  },
}
</script>
<template>
  <el-dialog :visible.sync="dialogMixinDialogVisible" :before-close="$DialogMixinOnClose" :custom-class="`${$style.dialogContact} isStyleContact`" width="876px" append-to-body>
    <div class="sectionTitle text-center mb-5 font-medium color-gray-7">取消報名</div>
    <div class="text-base md:text-lg dialogContact__content mb-5 text-md-left text-center">
      <p style="line-height: 2"> 您將取消此課程活動的報名，取消後您所佔的名額將會釋出。</p>
      <p class="text-center">確定要取消？</p>
    </div>
    <div class="d-flex justify-content-center">
      <BaseButton class="isStyleNormal isFull isRadius my-5 mx-1" @click="dialogMixinDialogVisible = !dialogMixinDialogVisible"> 取消 </BaseButton>
      <BaseButton class="isStylePrimary isFull isRadius my-5 mx-1" @click="confirm"> 確定 </BaseButton>
    </div>
    <!-- <BaseButton
      class="isStylePrimary isRadius isFull my-5"
      @click="dialogMixinDialogVisible = !dialogMixinDialogVisible"
    >
      我瞭解了
    </BaseButton> -->
  </el-dialog>
</template>
<style lang="scss" module>
.dialogContact {
  padding-right: 30px;
  padding-left: 30px;

  :global {
    .dialogContact {
      &__content {
        max-width: 35rem;
        margin: 0 auto;
      }
    }
    .sectionTitle {
      font-size: 24px;
    }
    .tel {
      &:hover,
      &:active {
        color: $color-primary;
        text-decoration: none;
      }
    }
  }
}
</style>
